export type FromToDayTimes = [string | null, string | null]

export const weekDays = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
]

export type IBusinessHoursByDays = {
  sunday: FromToDayTimes
  monday: FromToDayTimes
  tuesday: FromToDayTimes
  wednesday: FromToDayTimes
  thursday: FromToDayTimes
  friday: FromToDayTimes
  saturday: FromToDayTimes
}

const makeDefaultFromToDayTime = () => ['8:00', '18:00']

export const defaultBusinessHoursDays = () => {
  return weekDays.reduce((daysObject, day, i) => {
    if (i < 5) {
      daysObject[day] = makeDefaultFromToDayTime()
    } else {
      daysObject[day] = ['', '']
    }
    return daysObject
  }, {}) as IBusinessHoursByDays
}
